export default __webpack_public_path__ + "static/twitterdark-717a9f3db11105fd5f251c44429227c0.png";